import {FC} from "react";
import {newsData} from "../configs";
import {useAdminNewsConfigurator} from "../hooks";

export const News: FC = () => {
    const {isLoading, fetchedNews, hasError} = useAdminNewsConfigurator();
    const visibleNews = fetchedNews.filter(
        item => item.headline.trim() !== "" || item.body.trim() !== ""
    );

    return (
        <>
            <h2 className="text-3xl md:text-4xl font-bold text-red-500 mx-6 mt-6 md:mt-10 mb-6">
                {newsData.title}
            </h2>

            {isLoading ? (
                <p className="mx-6 text-gray-500">Načítám aktuality...</p>
            ) : hasError ? (
                <p className="mx-6">Došlo k chybě. Aktuality se nepodařilo načíst.</p>
            ) : fetchedNews.length === 0 ? (
                <p className="mx-6 text-gray-500">
                    Žádné aktuality nejsou k dispozici.
                </p>
            ) : (
                <ul className="mx-6 list-disc space-y-2">
                    {visibleNews.map((newsItem, index) => (
                        <li key={index}>
                            <span className="font-semibold">{newsItem.headline}</span>{" "}
                            <span>({newsItem.publishedOn})</span>
                            <p>{newsItem.body}</p>
                        </li>
                    ))}
                </ul>
            )}
        </>
    );
};
